var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.242,
    height: 38.563,
    viewBox: "0 0 74.242 38.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(-26.439 -3357.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 1137.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 36,
    y1: 36,
    transform: "translate(27.5 2221.5)",
    fill: "none",
    stroke: "#acacac",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 29,
    transform: "translate(27.5 2221.5)",
    fill: "none",
    stroke: "#acacac",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(36 1137.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-2",
    "data-name": "Line 1",
    y1: 36,
    x2: 36.122,
    transform: "translate(27.5 2221.5)",
    fill: "none",
    stroke: "#acacac",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2",
    "data-name": "Line 2",
    x2: 29.098,
    transform: "translate(34.524 2221.5)",
    fill: "none",
    stroke: "#acacac",
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.e65aeb2d.svg";
export { ForwardRef as ReactComponent };